import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: process.env.REACT_APP_DEFAULT_LANGUAGE || "es",
    supportedLngs: ["en", "es"],
    fallbackLng: process.env.REACT_APP_DEFAULT_LANGUAGE || "es",

    ns: ["LogisticNav", "LogisticHero", "LogisticPainSection", "LogisticSolutionSection", "LogisticFeaturesSection", "LogisticBenefitsSection", "LogisticUseCasesSection", "LogisticTestimonialsSection", "LogisticGuaranteeSection", "LogisticPricingSection", "LogisticUrgencySection", "LogisticCtaSection", "LogisticFaqSection", "LogisticFooter"],
    defaultNS: "translation",

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: true,
    },
  });


export default i18n;
